/**
 * Map a Firestore document snapshot to a plain object whose `id` is ALWAYS the
 * document path id (a string).
 *
 * Tasks and time records carry a numeric `id` field inside the document (we
 * write it so the Android Room app can ingest them). The naive
 * `{ id: doc.id, ...doc.data() }` lets that numeric field clobber the string
 * path id, so downstream `doc(firestore, path, task.id)` calls get a number and
 * throw ("path segment must be a string"). Spreading the data first and setting
 * `id` last guarantees the string path id wins — predictable for every caller.
 */
export const docToObject = (doc) => ({ ...doc.data(), id: doc.id });
